module.exports = __webpack_public_path__ + "img/personal-number-card.78e3ae16.png";